import _ from 'lodash';
import React, { PureComponent } from 'react';
import EBPropTypes from 'js-utils/prop-types';
import { FeatureInfo, FeatureInfoSecondaryCTA } from './_internal/features';
import Template from './_internal/Template';
import Image from './Image';
import {
    FEATURES_PROP_TYPES,
    TEMPLATE_PROP_TYPES,
    TEMPLATE_PROPS,
} from '../constants/componentPropTypes';

const _getFeatureListItems = (features) => {
    let listItems = null;

    if (features) {
        listItems = _.map(features, ({ heading, description, iconType }) => (
            <FeatureInfo
                key={iconType}
                iconType={iconType}
                heading={heading}
                description={description}
            />
        ));
    }

    return listItems;
};

const FeatureList = ({
    heading,
    features,
    secondaryCTAtext,
    secondaryCTAaction,
}) => {
    const featuresListItems = _getFeatureListItems(features);
    let secondaryCTA = null;

    if (secondaryCTAtext && secondaryCTAaction) {
        secondaryCTA = (
            <FeatureInfoSecondaryCTA
                text={secondaryCTAtext}
                action={secondaryCTAaction}
            />
        );
    }

    return (
        <section className="eds-l-pad-all-4">
            <h2 className="eds-text-hm eds-l-pad-vert-2 eds-text-color--grey-900">
                {heading}
            </h2>
            {featuresListItems}
            {secondaryCTA}
        </section>
    );
};

export default class TwoColumnFeatures extends PureComponent {
    static propTypes = {
        ...TEMPLATE_PROP_TYPES,
        ...FEATURES_PROP_TYPES,
        /*
        Main heading for the group of features
        */
        heading: EBPropTypes.translation,
    };

    render() {
        const {
            heading,
            features,
            imagePath,
            pageName,
            secondaryCTA,
            secondaryCTAaction,
        } = this.props;

        if (!heading) {
            return null;
        }

        const templateProps = _.pick(this.props, TEMPLATE_PROPS);

        return (
            <div>
                <Template
                    hasPadding={false}
                    showOnlyLargeScreen={true}
                    addSpaceBetween={true}
                    {...templateProps}
                >
                    <div className="eds-g-cell eds-g-cell-7-12 eds-l-pad-all-8">
                        <Image
                            imagePath={imagePath}
                            pageName={pageName}
                            altDescription={heading}
                        />
                    </div>
                    <div className="eds-g-cell eds-g-cell-4-12 eds-l-pad-all-8">
                        <FeatureList
                            heading={heading}
                            features={features}
                            secondaryCTAtext={secondaryCTA}
                            secondaryCTAaction={secondaryCTAaction}
                        />
                    </div>
                </Template>
                <Template
                    hasPadding={false}
                    showOnlySmallScreen={true}
                    {...templateProps}
                >
                    <Image
                        imagePath={imagePath}
                        pageName={pageName}
                        altDescription={heading}
                    />
                    <FeatureList heading={heading} features={features} />
                </Template>
            </div>
        );
    }
}
